/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-key */
/* eslint-disable react/no-danger */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Accordion, Col, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  MdKeyboardArrowDown,
  MdOutlineArrowBack,
  MdOutlineCreditCard,
} from 'react-icons/md';
import { CiBank, CiWallet } from 'react-icons/ci';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import {
  formatCurrency,
  formatDate,
  scrollToTop,
  getNewDate,
  getEligibilityForPaymentMode,
  isMobileWidth,
  hideHeaderFooterInMobile,
  showHeaderFooterInMobile,
  isEmpty,
  getCancellationPolicyFormat,
} from '../../../shared/helper-utils/appUtils';
// import NoSearchResults from '../../one-way/NoSearchResults';
import {
  API_DATE_FORMAT,
  checkValidEmailAddress,
  checkValidMobileNumber,
  checkValidName,
  checkValidPanNumber,
  DATE_MONTH_YEAR_FORMAT,
  DATE_MONTH_YEAR_VIEW_FORMAT,
  MONTH_FORMAT,
  NAVIGATION_ROUTES,
  // MONTH_TIME_FORMAT,
  ONLY_DATE_FORMAT,
  ONLY_DATE_MONTH_FORMAT,
} from '../../../shared/constants/Constants';
import AppLink from '../../../shared/components/app-link/AppLink';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import './BookingReview.scss';
import {
  bookHotelApi,
  calculateAge,
  holdHotelApi,
} from '../../../api/hotelApi';
import {
  getObjectFromLS,
  getUserAgentId,
  getValueFromAppConfig,
} from '../../../shared/helper-utils/localStorage';
import HotelPassengerDetails from './HotelPasengerDetails';
import AppModal from '../../../shared/components/app-modal/AppModal';
import TermsAndConditions from '../hotel-details/TermsAndCondition';
import AppRadioInput from '../../../shared/components/app-radio-input/AppRadioInput';
import StarRating from '../search-results/StarRating';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import AppCheckBox from '../../../shared/components/app-check-box/AppCheckBox';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import {
  NET_BANKING_OPTIONS,
  NET_BANKING_OPTIONS_LIVE,
  PAYU_BANKING_OPTIONS,
  PAYU_BANKING_OPTIONS_LIVE,
} from '../../../shared/constants/NetBankingOptions';
import AppIconButton from '../../../shared/components/app-icon-button/AppIconButton';
import PaymentGatewayApii from './PaymentGatewayApii';
import {
  addMarkupInTicket,
  getPGCheckOutAmountApi,
} from '../../../api/flightApi';
import AppSidebar from '../../../shared/components/app-sidebar/AppSidebar';
import { getUserDetails } from '../../../api/profileApi';
import { APP_USER_PROFILE } from '../../../saas/AppStorageStaticNames';
import { useAppContext } from '../../../saas/AppConfigWrapper';

export const HOTEL_PAX = {
  title: '',
  firstName: '',
  middleName: '',
  lastName: '',
  dob: '',
  paxType: '1',
  address1: 'blr',
  address2: 'blr',
  city: 'Bangalore',
  state: 'KA',
  countryCode: 'IN',
  countryName: getValueFromAppConfig('SAAS_HOTEL_PAX_COUNTRY'),
  paxCOR: getValueFromAppConfig('SAAS_HOTEL_PAX_COUNTRY'),
  zipcode: '560017',
  email: '',
  countryPhoneCode: !isEmpty(getValueFromAppConfig('SAAS_APP_MOBILE_CODE'))
    ? getValueFromAppConfig('SAAS_APP_MOBILE_CODE')
    : '+91',
  // mobile: '',
  phoneNumber: '',
  passportNumber: '',
  passportExpiry: '',
  panCardNumber: '',
};

function CheckInCard({ data }) {
  return (
    <div className="booking-review-page__body__booking-details_check-in-card">
      <span>{data.title}</span>
      <span className="pt-2 pb-2">
        {data.date ? formatDate(getNewDate(data.date), ONLY_DATE_FORMAT) : ''}
      </span>
      <span>{`${
        data.date ? formatDate(getNewDate(data.date), MONTH_FORMAT) : ''
      }`}</span>
    </div>
  );
}

CheckInCard.propTypes = {
  data: PropTypes.object.isRequired,
};

function ChargesCard({ data }) {
  return (
    <div className="booking-review-page__charges_card">
      <span>{data.title}</span>
      <span
        className=" hotel-results-watermarked"
        data-watermark={`${getUserAgentId()}`}
      >
        {formatCurrency(data.charge)}
      </span>
    </div>
  );
}

ChargesCard.propTypes = {
  data: PropTypes.object.isRequired,
};

function BookingReview() {
  const { appConfig } = useAppContext();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const { state } = useLocation();
  const {
    hotelDetails,
    searchRequest,
    roomDetails,
    bookingDataKey,
    selectedRoom,
    isPriceChanged,
  } = state;
  const [isLoading, setLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  // const [bookingDetails, setBookingDetails] = useState({});
  // const [isSearchDone, setSearchDone] = useState(false);
  const [contactDetails, setContactDetails] = useState({
    email: '',
    phoneNumber: '',
  });
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [errors, setErrors] = useState({});
  const [passengerErrorDict, setPassengerErrorDict] = useState({});
  const navigate = useNavigate();
  const [totRoomNights, setTotRoomNights] = useState(0);
  const [numPeople, SetNumPeople] = useState({
    totAdults: 0,
    totChilds: 0,
    totInfants: 0,
  });
  const [showTaxBreakupModal, setShowTaxBreakUpModal] = useState(false);
  const [fareBreakup, setFareBreakup] = useState([]);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [paymentMode, setPaymentMode] = useState('cashcard');
  const [showTerms, setShowTerms] = useState(false);
  const [appliedMarkup, setAppliedMarkup] = useState('');
  const [isPanRequired] = useState(
    roomDetails.roomType.ispan === 'true' ? true : false,
  );
  const [isPassportRequired] = useState(
    roomDetails.roomType.ispassport === 'true' ? true : false,
  );
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [selectedBankForNetBanking, setSelectedBankForNetBanking] =
    useState('');
  const [showNetFare, setShowNetFare] = useState(false);
  const [selectedPg, setSelectedPg] = useState('');
  const [checkoutPgCharge, setcheckoutPgCharge] = useState(0);
  const [checkoutgstPgCharge, setgstcheckoutPgCharge] = useState(0);
  const [checkoutInvTotal, setcheckoutInvTotal] = useState(0);
  const [tempMarkupList, setTempMarkupList] = useState([]);
  const [additionalMarkup, setAdditionalMarkup] = useState(0);
  const [showMarkup, setShowMarkup] = useState(false);
  const [viewFareSummary, setViewFareSummary] = useState(false);
  const totalFareRef = useRef('');
  const [agent, setAgent] = useState({});
  const [isPayuPgAccepted, setIsPayuPgAccepted] = useState(false);
  const [priceChangeModal, setPriceChangeModal] = useState(isPriceChanged);
  const [showMarkupOption, setShowMarkupOption] = useState(false);
  const contactDetailsRef = useRef(null);
  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);

  const getAgentDetails = async () => {
    setLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      if (!isEmpty(User)) {
        setAgent(User);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getAgentDetails();
    scrollToTop();
    const roomDetailsObj = {
      hotelCode: roomDetails.hotelCode,
      roomTypeCode: roomDetails.roomType.roomTypeCode,
      ratePlanCode: roomDetails.ratePlan.ratePlanCode,
      roomTypeName: roomDetails.roomType.roomTypeName,
      // roomNumber: roomDetails.roomNumber,
      resultindex: roomDetails.resultindex,
    };
    const markupList = [];
    const selectedRoomsArray = searchRequest.roomRequirements.map(
      (d, index) => {
        const adults = Number(d.adults || 0);
        const childs = Number(d.childs || 0);
        const childAge = Number(d.childAges || 0);

        const paxList = [];

        if (adults > 0) {
          Array.from({ length: adults }, (v, k) => k).forEach(() => {
            paxList.push({
              ...HOTEL_PAX,
              paxType: '1',
              roomNumber: index + 1,
            });
            markupList.push({ Type: 'Adult', tax_amount: '' });
          });
        }
        if (childs > 0) {
          Array.from({ length: childs }, (v, k) => k).forEach((x, xIndex) => {
            paxList.push({
              ...HOTEL_PAX,
              paxType: '2',
              age: d.childAges.split(',')[xIndex],
              roomNumber: index + 1,
            });
            // markupList.push({ Type: 'Child', tax_amount: '' });
          });
        }
        return {
          ...d,
          roomPassengers: { paxList, roomDetails: roomDetailsObj },
        };
      },
    );
    setTempMarkupList(markupList);
    let numAdults = 0;
    let numChilds = 0;
    let numInfants = 0;
    searchRequest.roomRequirements.forEach((d) => {
      const adults = Number(d.adults || 0);
      const childs = Number(d.childs || 0);
      const infants = Number(d.infants || 0);
      numAdults += adults;
      numChilds += childs;
      numInfants += infants;
    });
    SetNumPeople((prev) => ({
      ...prev,
      totAdults: numAdults,
      totChilds: numChilds,
      totInfants: numInfants,
    }));
    const totNights =
      (getNewDate(searchRequest.checkOutSearch) -
        getNewDate(searchRequest.checkInSearch)) /
      (1000 * 60 * 60 * 24);
    const breakupArray = roomDetails.nextrabreakupenc.split(':');
    setFareBreakup(breakupArray);
    totalFareRef.current = {
      totalFare: Number(breakupArray[10]),
      totalTax: parseInt(roomDetails.ratePlan.totalTax, 10),
    };
    setTotRoomNights(totNights);
    setSelectedRooms(selectedRoomsArray);
  }, []);

  const getPaxList = () => {
    const paxListObject = [];
    selectedRooms.forEach((room) => {
      room.roomPassengers.paxList.forEach((pax) => {
        pax.phoneNumber = contactDetails.phoneNumber;
        pax.email = contactDetails.email;

        // Format passportExpiry if it exists
        if (pax.passportExpiry) {
          pax.passportExpiry = formatDate(
            getNewDate(pax.passportExpiry),
            DATE_MONTH_YEAR_FORMAT,
          );
        }
        // Format dob if it exists
        if (pax.dob) {
          pax.age = calculateAge(
            formatDate(getNewDate(pax.dob), API_DATE_FORMAT),
            searchRequest.checkInSearch,
          );
          pax.childAge = calculateAge(
            formatDate(getNewDate(pax.dob), API_DATE_FORMAT),
            searchRequest.checkInSearch,
          );
          pax.dob = formatDate(getNewDate(pax.dob), DATE_MONTH_YEAR_FORMAT);
        }
        paxListObject.push(pax);
      });
    });
    return paxListObject; // Return the modified list of rooms with updated paxList
  };

  const bookAHotel = async () => {
    setLoading(true);
    const agentId = getUserAgentId();
    let bankId = '';
    if (
      paymentMode === 'netbanking' &&
      (selectedPg === 'techprocessv2' ||
        selectedPg === 'techprocessv2_netbanking' ||
        selectedPg === 'payu')
    ) {
      bankId = selectedBankForNetBanking;
    }
    const request = {
      repriceResponseId: bookingDataKey,
      supphold: hotelDetails.supphold,
      totrooms: searchRequest.totrooms,
      bookingtype: 'b2b',
      propertyPhoneNumber: hotelDetails.propertyPhoneNumber,
      propertyFaxNumber: hotelDetails.propertyFaxNumber,
      propertyEmail: hotelDetails.propertyEmail,
      checkin: searchRequest.checkIn,
      checkout: searchRequest.checkOut,
      propertyName: hotelDetails.propertyName,
      starRating: hotelDetails.starRating,
      thumbnail: hotelDetails.thumbnail,
      address: hotelDetails.shortaddr,
      city: searchRequest.city,
      country: searchRequest.country,
      displayCurrencyRoe: 1.0,
      fareSource: selectedRoom.fareSource,
      propertyCode: selectedRoom.providerHotelCode,
      roomsToBook: [
        {
          roomTypeCode: roomDetails.roomType.roomTypeCode,
          roomTypeName: roomDetails.roomType.roomTypeName,
          ratePlanCode: roomDetails.ratePlan.ratePlanCode,
          ratePlanName: roomDetails.ratePlan.ratePlanName,
          meals: roomDetails.ratePlan.meals,
          isPostPaid: roomDetails.ratePlan.isPostPaid || false,
          bookingKey: roomDetails.bookingKey,
          totalTax: roomDetails.ratePlan.totalTax,
          currency: appConfig?.appCurrency,
          currencyconvrate: '1',
          nextratotalprice: roomDetails.nextratotalprice,
          nextrafarequoteprice: roomDetails.nextrafarequoteprice,
          nextrabreakupenc: roomDetails.nextrabreakupenc,
          nextraoriginalbreakupenc: roomDetails.nextraoriginalbreakupenc,
          ytbreakup: roomDetails.ytbreakup,
          cancellationPolicy: {
            // hotelcanxpolicy:
            //   roomDetails.ratePlan.cancellationPolicy.hotelcanxpolicy === ''
            //     ? selectedRoom.ratePlan.cancellationPolicy.hotelcanxpolicy
            //     : roomDetails.ratePlan.cancellationPolicy.hotelcanxpolicy,

            hotelcanxpolicy: roomDetails?.ratePlan?.cancellationPolicy
              ?.hotelcanxpolicy
              ? roomDetails.ratePlan.cancellationPolicy.hotelcanxpolicy
              : selectedRoom?.ratePlan?.cancellationPolicy?.hotelcanxpolicy ||
                '-',
            terms:
              roomDetails.ratePlan.cancellationPolicy.terms.length === 0
                ? selectedRoom.ratePlan.cancellationPolicy.terms
                : roomDetails.ratePlan.cancellationPolicy.terms,

            // canxpolicy_modified:
            //   roomDetails.ratePlan.cancellationPolicy.canxpolicy_modified ===
            //   undefined
            //     ? selectedRoom.ratePlan.cancellationPolicy.canxpolicy_modified
            //     : roomDetails.ratePlan.cancellationPolicy.canxpolicy_modified,

            canxpolicy_modified:
              roomDetails?.ratePlan?.cancellationPolicy?.canxpolicy_modified !==
              undefined
                ? roomDetails.ratePlan.cancellationPolicy.canxpolicy_modified
                : selectedRoom?.ratePlan?.cancellationPolicy
                    ?.canxpolicy_modified || '-',

            freeCancellationAllowed:
              roomDetails.ratePlan.cancellationPolicy.freeCancellationAllowed,

            freeCancellationDeadline:
              roomDetails?.ratePlan?.cancellationPolicy
                ?.freeCancellationDeadline || '-',
            // freeCancellationDeadline:
            //   roomDetails?.ratePlan?.cancellationPolicy
            //     ?.freeCancellationDeadline,
          },
        },
      ],
      paxList: getPaxList(),
      // paxList:selectedRooms[0].roomPassengers.paxList,
    };
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const response = await bookHotelApi(
      request,
      agentId,
      bankId,
      paymentMode,
      selectedPg,
    );
    if (
      response?.ApiStatus?.Status === 'OK' ||
      response?.Root?.Status === 'OK'
    ) {
      let txid;
      if (paymentMode === 'cashcard') {
        txid = response?.Root?.Result;
      } else {
        txid = response?.Root?.Result?.Txid;
      }
      const markUpTobeAdded =
        additionalMarkup === '' ? 0 : parseInt(additionalMarkup, 10);
      const markupResponse = await addMarkupInTicket(
        userProfile?.agentId,
        txid,
        markUpTobeAdded,
      );
      if (markupResponse && markupResponse?.Root?.Status === 'OK') {
        if (response?.Root?.Status === 'OK') {
          if (paymentMode === 'cashcard') {
            setAlert({
              variant: 'success',
              title:
                response.ApiStatus?.Message ||
                formattedMessage('hotel_booking_success'),
              description: formattedMessage('hotel_booking_success_alert'),
            });
            setTimeout(() => {
              navigate(
                `${NAVIGATION_ROUTES.MY_BOOKINGS_ROUTE}?transactionType=hotelBookings`,
              );
            }, 2000);
          } else {
            const { Result } = response.Root;
            if (Result !== '') {
              const { PgUrl, Txid } = Result;
              let urlToRedirect = `${PgUrl}?txid=${Txid}`;
              if (paymentMode === 'netbanking') {
                urlToRedirect += `&bankcode=${selectedBankForNetBanking}`;
              }
              window.open(urlToRedirect, '_blank');
            }
          }
        } else {
          setAlert({
            variant: 'error',
            title: formattedMessage('hotel_booking_title'),
            description: response?.ApiStatus?.Message,
          });
        }
      }
    } else {
      setAlert({
        variant: 'error',
        title: formattedMessage('hotel_booking_title'),
        description: response?.Root?.Message,
      });
    }

    setLoading(false);
  };
  const holdHotel = async () => {
    setShowConfirmationPopup(false);
    if (paymentMode !== 'cashcard') {
      setAlert({
        variant: 'error',
        title: 'Hotel Book',
        description: 'Hold cannot be done with payment gateway',
      });
      return;
    }
    setLoading(true);
    const agentId = getUserAgentId();
    const request = {
      repriceResponseId: bookingDataKey,
      supphold: hotelDetails.supphold,
      totrooms: searchRequest.totrooms,
      bookingtype: 'b2b',
      propertyPhoneNumber: hotelDetails.propertyPhoneNumber,
      propertyFaxNumber: hotelDetails.propertyFaxNumber,
      propertyEmail: hotelDetails.propertyEmail,
      checkin: searchRequest.checkIn,
      checkout: searchRequest.checkOut,
      propertyName: hotelDetails.propertyName,
      starRating: hotelDetails.starRating,
      // thumbnail: hotelDetails.thumbnail,
      address: hotelDetails.shortaddr,
      city: searchRequest.city,
      country: searchRequest.country,
      displayCurrencyRoe: 1.0,
      fareSource: hotelDetails.fareSource,
      propertyCode: hotelDetails.propertyCode,
      roomsToBook: [
        {
          roomTypeCode: roomDetails.roomType.roomTypeCode,
          roomTypeName: roomDetails.roomType.roomTypeName,
          ratePlanCode: roomDetails.ratePlan.ratePlanCode,
          ratePlanName: roomDetails.ratePlan.ratePlanName,
          meals: roomDetails.ratePlan.meals,
          isPostPaid: roomDetails.ratePlan.isPostPaid || false,
          bookingKey: roomDetails.bookingKey,
          totalTax: roomDetails.ratePlan.totalTax,
          currency: appConfig?.appCurrency,
          currencyconvrate: '1',
          nextratotalprice: roomDetails.nextratotalprice,
          nextrafarequoteprice: roomDetails.nextrafarequoteprice,
          nextrabreakupenc: roomDetails.nextrabreakupenc,
          nextraoriginalbreakupenc: roomDetails.nextraoriginalbreakupenc,
          ytbreakup: roomDetails.ytbreakup,
          cancellationPolicy: {
            hotelcanxpolicy:
              roomDetails.ratePlan.cancellationPolicy.hotelcanxpolicy === ''
                ? selectedRoom.ratePlan.cancellationPolicy.hotelcanxpolicy
                : roomDetails.ratePlan.cancellationPolicy.hotelcanxpolicy,
            terms:
              roomDetails.ratePlan.cancellationPolicy.terms.length === 0
                ? selectedRoom.ratePlan.cancellationPolicy.terms
                : roomDetails.ratePlan.cancellationPolicy.terms,
            canxpolicy_modified:
              roomDetails.ratePlan.cancellationPolicy.canxpolicy_modified ===
              undefined
                ? selectedRoom.ratePlan.cancellationPolicy.canxpolicy_modified
                : roomDetails.ratePlan.cancellationPolicy.canxpolicy_modified,
            freeCancellationAllowed:
              roomDetails.ratePlan.cancellationPolicy.freeCancellationAllowed,
            freeCancellationDeadline:
              roomDetails?.ratePlan?.cancellationPolicy
                ?.freeCancellationDeadline,
          },
        },
      ],

      paxList: getPaxList(),
    };
    const response = await holdHotelApi(request, agentId, paymentMode);
    if (response?.ApiStatus?.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Hold Hotel',
        description: 'Hotel hold performed successfully.',
      });
      let link = NAVIGATION_ROUTES.HOTEL.VOUCHER;
      link = link.replace(':transactionId', response?.ApiStatus.Result);
      setTimeout(() => {
        navigate(link);
      }, 2000);
    }
    if (response?.Root?.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Hold Hotel',
        description: 'Hotel hold performed successfully.',
      });
      let link = NAVIGATION_ROUTES.HOTEL.VOUCHER;
      link = link.replace(':transactionId', response?.Root.Result);
      setTimeout(() => {
        navigate(link);
      }, 2000);
    } else {
      setAlert({
        variant: 'error',
        title: 'Hold Hotel',
        description: response?.ApiStatus
          ? response?.ApiStatus?.Message
          : response?.Root
          ? response?.Root?.Message
          : 'Failed to perform hold.',
      });
    }
    setLoading(false);
  };
  // const hasDuplicatePanCardNumber = () => {
  //   try {
  //     let hasDupe = false;
  //     const pan = selectedRooms.reduce((acc, cur) => {
  //       const childpan = cur.roomPassengers.paxList
  //         .filter((x) => !isEmpty(x.panCardNumber))
  //         .map((x) => x.panCardNumber);
  //       return acc.concat(childpan);
  //     }, []);
  //     hasDupe = new Set(pan).size !== pan.length;
  //     return hasDupe;
  //   } catch (error) {
  //     return false;
  //   }
  // };
  const payNowButtonClick = async () => {
    const errorsObj = {};
    if (
      contactDetails.email === '' ||
      contactDetails.email === null ||
      contactDetails.email === undefined
    ) {
      errorsObj.email = formattedMessage('enter_email');
    }
    if (
      contactDetails.phoneNumber === '' ||
      contactDetails.phoneNumber === null ||
      contactDetails.phoneNumber === undefined
    ) {
      errorsObj.phoneNumber = formattedMessage('enter_phone_number');
    }
    if (checkValidEmailAddress(contactDetails.email)) {
      errorsObj.validEmail = formattedMessage('email_id_validation');
    }
    if (checkValidMobileNumber(contactDetails.phoneNumber)) {
      errorsObj.validPhoneNumber = formattedMessage('enter_valid_phone_number');
    }
    const paxErrorDict = {};
    selectedRooms.forEach((ele, index) => {
      ele.roomPassengers.paxList.forEach((d, dIndex) => {
        const key = index * ele.roomPassengers.paxList.length + dIndex;
        paxErrorDict[key] = paxErrorDict[key] || {};

        if (!d.title)
          paxErrorDict[key].title = formattedMessage('title_select');

        if (!d.firstName)
          paxErrorDict[key].firstName = formattedMessage(
            'first_name_validation',
          );

        if (d.firstName.length > 30)
          paxErrorDict[key].firstName =
            'First name should be less than 30 letters';

        if (d.firstName.length > 0 && checkValidName(d.firstName))
          paxErrorDict[key].validFirstName =
            formattedMessage('name_validation');
        if (getValueFromAppConfig('ENABLE_LASTNAME_VALIDATION') === 'true') {
          if (!d.lastName)
            paxErrorDict[key].lastName = formattedMessage(
              'last_name_validation',
            );
          if (d.lastName.length > 0 && checkValidName(d.lastName))
            paxErrorDict[key].validLastName =
              formattedMessage('name_validation');
        }

        // if (d.paxType === '2' && !d.dob)
        //   paxErrorDict[key].dob = formattedMessage('enter_date_of_birth');

        if (isPanRequired && d.paxType === '1') {
          if (!d.panCardNumber || d.panCardNumber.trim() === '') {
            paxErrorDict[key].panCardNumber = formattedMessage(
              'pan_number_validation',
            );
          } else if (!/^[a-zA-Z0-9]{10}$/.test(d.panCardNumber)) {
            paxErrorDict[key].panCardNumber = formattedMessage(
              'enter_valid_pan_number',
            );
          }
          // else if (hasDuplicatePanCardNumber()) {
          //   paxErrorDict[key].panCardNumber = 'PAN Number Should be unique';
          // }
        }
        if (isPassportRequired) {
          if (!d.ppNumber)
            paxErrorDict[key].ppNumber = formattedMessage(
              'passport_number_validation',
            );
          if (!d.ppExpiry)
            paxErrorDict[key].ppExpiry = formattedMessage(
              'enter_passport_expiry',
            );
        }

        if (Object.keys(paxErrorDict[key]).length === 0)
          delete paxErrorDict[key];
      });
    });

    setErrors(errorsObj);
    // auto scroll to contact section error
    if (
      errorsObj.email ||
      errorsObj.phoneNumber ||
      errorsObj.validEmail ||
      errorsObj.validPhoneNumber
    ) {
      contactDetailsRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      return;
    }

    setPassengerErrorDict(paxErrorDict);
    if (!acceptTerms) {
      errorsObj.terms = formattedMessage('terms_conditions_alert');
      setAlert({
        title: formattedMessage('hotel_booking_title'),
        description: formattedMessage('terms_conditions_alert'),
        variant: 'error',
      });
    }

    // if (paymentMode === 'netbanking' && selectedBankForNetBanking === '') {
    //   errorsObj.pgError = 'Please select bank';
    //   setAlert({
    //     title: formattedMessage('hotel_booking_title'),
    //     description: 'Please select a bank',
    //     variant: 'error',
    //   });
    // }

    let bankId = '';
    if (
      paymentMode === 'netbanking' &&
      (selectedPg === 'techprocessv2' ||
        selectedPg === 'techprocessv2_netbanking' ||
        selectedPg === 'payu')
    ) {
      bankId = selectedBankForNetBanking;
    }
    if (
      Object.keys(errorsObj).length === 0 &&
      Object.keys(paxErrorDict).length === 0
    ) {
      // setLoading(true);
      const pgcheckoutamount = await getPGCheckOutAmountApi(
        paymentMode,
        selectedPg,
        '',
        fareBreakup[10],
        'hotel',
        getUserAgentId(),
        bankId,
      );
      if (pgcheckoutamount?.ApiStatus?.Status === 'OK') {
        setLoading(false);
        const { Result } = pgcheckoutamount.ApiStatus;
        setcheckoutPgCharge(Result.PgCharges);
        setgstcheckoutPgCharge(Result.GSTOnPgCharges);
        setcheckoutInvTotal(Result.TotalInvoice);
      }
      setShowConfirmationPopup(true);
    }
  };

  const handleUpdateSearchState = (name, value) => {
    setContactDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    handleUpdateSearchState(name, value);
  };

  const onPassengerUpdate = (list) => {
    setSelectedRooms(list);
  };

  const handlePgSelect = (pgName) => {
    setSelectedPg(pgName);
  };

  const handleAddMarkupForPax = (event, index) => {
    const { name, value } = event.target;
    const numValue = value.replace(/[^0-9]/g, '');
    const list = [...tempMarkupList];
    list[index][name] = numValue;
    setTempMarkupList(list);
  };

  const handleMarkupAddition = () => {
    const list = [...tempMarkupList];
    list.forEach((pax) => {
      if (pax.tax_amount === '') {
        pax.tax_amount = 0;
      } else {
        const numValue = Number(pax.tax_amount);
        pax.tax_amount = numValue;
      }
    });
    let markUpValue = 0;
    list.forEach((pax) => {
      markUpValue += pax.tax_amount;
    });
    let totFare = Number(fareBreakup[10]);
    totFare += Number(markUpValue);
    totalFareRef.current.AdditionalMarkupToShow = Number(markUpValue);
    totalFareRef.current.totalFare = totFare;
    // const paxList = [...travellers];
    // paxList.forEach((pax, index) => {
    //   pax.additional_taxhc = list[index].tax_amount;
    // });
    setTempMarkupList(list);
    // setTravellers(paxList);
    setAdditionalMarkup(markUpValue);
    setShowMarkup(true);
    setAlert({
      title: 'Additional Markup',
      description: 'Successfully Added Markup',
      variant: 'success',
    });
  };

  const decodeHtmlEntities = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.documentElement.textContent;
  };

  return (
    <>
      <div className="booking-review-page_container_header hide-in-mobile"></div>
      <section className="booking-review-page_container">
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            onHide={() => setAlert(undefined)}
            description={alert.description}
          />
        )}
        {searchRequest && isMobileWidth() && (
          <div
            className="modify-search-container"
            style={{ marginTop: '60px' }}
          >
            <div className="d-flex">
              <AppIconButton
                onClick={() => navigate(-1)}
                className="white-color"
                variant="transparent"
              >
                <MdOutlineArrowBack />
              </AppIconButton>

              <div className="d-flex justify-content-between p-2 align-items-center flex-1">
                <div className="fs-14 white-color">
                  Hotels in {searchRequest.city}
                  <div className="fs-10">
                    {formatDate(
                      getNewDate(searchRequest.checkInSearch),
                      ONLY_DATE_MONTH_FORMAT,
                    )}{' '}
                    To{' '}
                    {formatDate(
                      getNewDate(searchRequest.checkOutSearch),
                      DATE_MONTH_YEAR_VIEW_FORMAT,
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {Object.keys(hotelDetails).length > 0 && (
          <div className="booking-review-page_container_content">
            <Row className="spacing-8">
              <Col lg={9}>
                <div className="booking-review-page__body">
                  <div className="p-3 d-flex justify-content-end border-bottom hide-in-mobile">
                    <AppLink
                      linkText="Back to hotel details"
                      variant="primary"
                      className="fw-600"
                      onClick={() => navigate(-1)}
                    />
                  </div>
                  <div className="booking-review-page__header  hide-in-mobile">
                    <div className="booking-review-page__header_title">
                      {formattedMessage('review_booking_title')}
                    </div>
                  </div>
                  <div className="booking-review-page__body_content">
                    <div className="d-flex flex-sm-row flex-column">
                      <div>
                        <img
                          src={
                            hotelDetails?.thumbnail ||
                            '/images/others/hotel-empty.jpg'
                          }
                          alt={formattedMessage('room')}
                          className="booking-review-page__body__other-image"
                          onError={(e) =>
                            (e.target.src = '/images/others/hotel-empty.jpg')
                          }
                        />
                      </div>
                      <div className="d-flex flex-column px-sm-3 px-0 py-2">
                        <div className="d-flex gap-2 flex-wrap">
                          <span className="booking-review-page__body__booking-details_hotel-name">
                            {hotelDetails.propertyName}
                          </span>
                          <StarRating rating={hotelDetails.starRating} />
                        </div>
                        <span className="booking-review-page__body__booking-details_hotel-location">
                          {hotelDetails.shortaddr}
                        </span>
                        <div className="d-flex gap-2 flex-column flex-sm-row mt-2">
                          <div className="d-flex gap-2">
                            <CheckInCard
                              data={{
                                title: formattedMessage('check_in'),
                                date: searchRequest.checkInSearch,
                                time:
                                  hotelDetails.checkInTime ||
                                  formattedMessage('n_a'),
                              }}
                            />
                            <CheckInCard
                              data={{
                                title: formattedMessage('check_out'),
                                date: searchRequest.checkOutSearch,
                                time:
                                  hotelDetails.checkOutTime ||
                                  formattedMessage('n_a'),
                              }}
                            />
                          </div>
                          <div className="booking-review-page__body__room-details">
                            <div className="fs-16 fw-600">
                              {roomDetails.roomType.roomTypeName}
                            </div>
                            <div className="fs-10">
                              {selectedRoom.roomType.description}
                            </div>
                            <div className="fs-14 mb-2">
                              {formattedMessage('for')}{' '}
                              {searchRequest.totalPeople}{' '}
                              {formattedMessage('people')}
                            </div>
                            <div className="d-flex gap-2 fs-14">
                              <span className="primary-color">{}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="px-3 py-2">
                    <div className="fs-16 fw-600 px-2 mb-1">
                      {/* {totRoomNights} {formattedMessage('days')} &{' '} */}
                      {totRoomNights} {formattedMessage('nights')}
                    </div>
                    <div className="p-2 border">
                      <span className="fs-14 fw-500">
                        {formattedMessage('meal_plan')}
                      </span>
                      {' : '}
                      <span className="fs-14">
                        {roomDetails?.ratePlan?.meals}
                        {/* {hotelDetails.amenitiesList?.join(', ')} */}
                      </span>
                    </div>
                    <div className="p-2 border">
                      <span className="fs-14 fw-500">
                        {formattedMessage('inclusions')}
                      </span>
                      {' : '}
                      <span className="fs-14">
                        {roomDetails?.ratePlan?.inclusions.join(', ')}
                        {/* {hotelDetails.amenitiesList?.join(', ')} */}
                      </span>
                    </div>
                    <div className="pt-2">
                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            {formattedMessage('terms_and_conditions')}
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="p-1">
                              <span className="fs-14 fw-500">
                                {formattedMessage('cancellation_policy')}
                              </span>
                              {' : '}
                              <span className="fs-14">
                                {getCancellationPolicyFormat(
                                  roomDetails?.ratePlan?.cancellationPolicy
                                    .formattedpolicies,
                                )}
                              </span>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
                <div className="separator" />
                <div
                  ref={contactDetailsRef}
                  className="booking-review-page__body p-3"
                >
                  <div className="fs-5 fw-600">
                    {formattedMessage('contact_details')}
                  </div>
                  <div className="booking-review-page__body_secondary-title">
                    {formattedMessage('contact_travel_details_sub_header')}
                  </div>
                  <Row className="mt-2 spacing-8">
                    <Col lg={4} md={4} sm={6}>
                      <AppTextInput
                        placeholderText=""
                        label={formattedMessage('email_btn')}
                        value={contactDetails.email}
                        name="email"
                        required
                        onChange={handleChange}
                        errorText={errors.email}
                      />
                      {checkValidEmailAddress(contactDetails.email) &&
                        !isEmpty(contactDetails.email) && (
                          <small className="app-error-text">
                            {errors.validEmail}
                          </small>
                        )}
                    </Col>
                    <Col lg={4} md={4} sm={6}>
                      <AppNumberInput
                        label={formattedMessage('phone_number')}
                        placeholderText=""
                        value={contactDetails.phoneNumber}
                        name="phoneNumber"
                        required
                        onChange={(value) =>
                          handleUpdateSearchState('phoneNumber', value)
                        }
                        errorText={errors.phoneNumber}
                      />
                      <small className="app-error-text">
                        {errors.validPhoneNumber}
                      </small>
                    </Col>
                  </Row>
                </div>
                <div className="separator" />
                <div className="booking-review-page__body p-3 overflow-visible">
                  {selectedRooms.length > 0 && (
                    <div className="pt-1">
                      <HotelPassengerDetails
                        passengerList={selectedRooms}
                        onPassengerUpdate={onPassengerUpdate}
                        passengerErrorDict={passengerErrorDict}
                        isPan={isPanRequired}
                        isPassport={isPassportRequired}
                      />
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={3} className="px-3">
                <div className="hotel-fare-summary hide-in-mobile">
                  <div className="hotel-fare-summary_header fw-600 d-flex justify-content-between align-items-center">
                    <div>{formattedMessage('charges')}</div>
                    <AppIconButton
                      className="p-0 fs-16"
                      variant="white"
                      onClick={() => setShowNetFare((prev) => !prev)}
                    >
                      {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
                    </AppIconButton>
                  </div>
                  <div className="hotel-fare-summary_content">
                    {getValueFromAppConfig('HIDEBREAKUPINHOTELBOOKINGPAGE') !==
                      'true' && (
                      <>
                        <div className="row spacing-0">
                          <div className="col-auto">
                            {formattedMessage('hotel_charges')}(+)
                          </div>
                          <div
                            className="col hotel-results-watermarked"
                            data-watermark={`${getUserAgentId()}`}
                          >
                            {formatCurrency(
                              parseInt(fareBreakup[0], 10) -
                                parseInt(totalFareRef.current.totalTax, 10),
                            )}
                          </div>
                        </div>
                        <div className="row spacing-0">
                          <div className="col-auto">
                            Taxes & Service Charges(+)
                          </div>
                          <div
                            className="col hotel-results-watermarked"
                            data-watermark={`${getUserAgentId()}`}
                          >
                            {formatCurrency(
                              parseInt(totalFareRef.current.totalTax, 10) +
                                parseInt(fareBreakup[8], 10) +
                                parseInt(fareBreakup[6], 10) +
                                parseInt(fareBreakup[4], 10),
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {showNetFare && (
                      <>
                        {getValueFromAppConfig(
                          'HIDEBREAKUPINHOTELBOOKINGPAGE',
                        ) !== 'true' && (
                          <>
                            <div className="row spacing-0">
                              <div className="col-auto">
                                {formattedMessage('agency_commission')}(-)
                              </div>
                              <div
                                className="col hotel-results-watermarked"
                                data-watermark={`${getUserAgentId()}`}
                              >
                                {formatCurrency(fareBreakup[3])}
                              </div>
                            </div>
                            <div className="row spacing-0">
                              <div className="col-auto">
                                {formattedMessage('tds')}(+)
                              </div>
                              <div
                                className="col hotel-results-watermarked"
                                data-watermark={`${getUserAgentId()}`}
                              >
                                {formatCurrency(fareBreakup[5])}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="row spacing-0">
                          <div className="col-auto">Net Fare</div>
                          <div
                            className="col hotel-results-watermarked"
                            data-watermark={`${getUserAgentId()}`}
                          >
                            {formatCurrency(fareBreakup[9])}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="hotel-fare-summary_footer fs-12 fw-600 p-3">
                    <div className="d-flex justify-content-between">
                      <span>{formattedMessage('total_fare')}</span>
                      <span
                        className=" hotel-results-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {formatCurrency(totalFareRef.current.totalFare)}
                      </span>
                    </div>
                  </div>
                </div>
                {getValueFromAppConfig('SHOWADDMARKUPINBOOKINGPAGE') ===
                  'show' && (
                  <div className="flight-booking-page_apply-markup mt-3 p-3 d-flex flex-column gap-2">
                    <div className="text-center fs-14 fw-600 d-flex justify-content-between">
                      {formattedMessage('apply_markup')}
                      <AppIconButton
                        className="p-0 fs-16"
                        onClick={() => setShowMarkupOption((prev) => !prev)}
                      >
                        {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
                      </AppIconButton>
                    </div>
                    {showMarkupOption && (
                      <>
                        {tempMarkupList.map(
                          (pax, index) =>
                            pax.Type !== 'Infant' && (
                              <div key={index} className="my-2">
                                <AppTextInput
                                  label={`Markup For ${pax.Type} ${
                                    pax.Type === 'Child'
                                      ? index +
                                        1 -
                                        parseInt(numPeople.totAdults, 10)
                                      : index + 1
                                  }`}
                                  value={pax.tax_amount}
                                  className="w-100"
                                  name="tax_amount"
                                  placeholderText=""
                                  onChange={(event) =>
                                    handleAddMarkupForPax(event, index)
                                  }
                                />
                              </div>
                            ),
                        )}
                        <AppButton
                          btnText={formattedMessage('apply_btn')}
                          className="fs-12 white-color"
                          variant="select"
                          onClick={handleMarkupAddition}
                        />
                      </>
                    )}
                  </div>
                )}
              </Col>
            </Row>
            <Row className="spacing-8 my-2">
              {!isMobileWidth() ? (
                <Col lg={9} className="d-flex flex-column pb-5">
                  <div className="flight-booking-page_content">
                    <div className="py-2 px-3 fs-5 fw-600">Payment options</div>
                    <div className="d-flex cursor-pointer">
                      {getEligibilityForPaymentMode('wallet') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center border-start fw-500 ${
                            paymentMode === 'cashcard'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('cashcard')}
                        >
                          <CiWallet />
                          Wallet
                        </div>
                      )}
                      {getEligibilityForPaymentMode('creditcard') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                            paymentMode === 'creditcard'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('creditcard')}
                        >
                          {' '}
                          <MdOutlineCreditCard /> CreditCard
                        </div>
                      )}
                      {getEligibilityForPaymentMode('debitcard') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                            paymentMode === 'debitcard'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('debitcard')}
                        >
                          {' '}
                          <MdOutlineCreditCard /> DebitCard
                        </div>
                      )}
                      {getEligibilityForPaymentMode('netbanking') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                            paymentMode === 'netbanking'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('netbanking')}
                        >
                          <CiBank />
                          Netbanking
                        </div>
                      )}
                      {getEligibilityForPaymentMode('upi') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center  fw-500 ${
                            paymentMode === 'upi'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('upi')}
                        >
                          <CiBank />
                          UPI
                        </div>
                      )}
                    </div>
                    {paymentMode !== 'cashcard' && paymentMode !== '' && (
                      <PaymentGatewayApii
                        paymentModeClicked={paymentMode}
                        selectedPgForPaymentMode={selectedPg}
                        onPgSelect={handlePgSelect}
                      />
                    )}
                    {paymentMode === 'netbanking' &&
                      paymentMode !== 'cashcard' &&
                      paymentMode !== '' &&
                      isEmpty(getValueFromAppConfig('disableDropDown')) && (
                        <div className="d-flex justify-content-start p-3">
                          <AppSelect
                            name="selected_bank"
                            id="selected_bank"
                            label="Select Bank"
                            placeholder=""
                            selectWidth="300px"
                            isClearable={false}
                            options={NET_BANKING_OPTIONS_LIVE}
                            selectedValue={selectedBankForNetBanking}
                            onSelect={(dataObj) =>
                              setSelectedBankForNetBanking(dataObj.value)
                            }
                          />
                        </div>
                      )}
                    {paymentMode !== '' &&
                      paymentMode !== 'cashcard' &&
                      selectedPg === 'payu' && (
                        <div className="px-3 d-flex flex-column">
                          <p className="mb-2 px-4 fs-14">
                            Accept Terms and Conditions of <b>payu</b>
                          </p>
                          <AppCheckBox
                            labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                            id="payuPgAccepted"
                            name="payuPgAccepted"
                            radioClassName="w-25px"
                            checked={isPayuPgAccepted}
                            labelClassName="fs-12"
                            onChange={() =>
                              setIsPayuPgAccepted((prev) => !prev)
                            }
                          />
                          <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                            <img
                              src="/images/others/payu.jpg"
                              alt=""
                              height="20px"
                            />
                            <img
                              src="/images/others/visa_mastercard.gif"
                              alt=""
                              height="20px"
                            />
                            <span>
                              (Only Personal Credit Cards @ 1.77% | Rupay Debit
                              Card allowed @0.25%)
                            </span>
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="separator" />
                  <div className="flight-booking-page_content p-3 d-flex justify-content-between d-column d-md-row">
                    <AppCheckBox
                      labelText={formattedMessage(
                        'i_have_read_and_accept_terms_and_conditions',
                      )}
                      id="acceptTerms"
                      name="acceptTerms"
                      checked={acceptTerms}
                      labelClassName="fs-12"
                      onChange={() => setAcceptTerms((prev) => !prev)}
                    />
                    <div className="d-flex gap-2 align-items-center">
                      <div
                        className="fs-4 fw-600 hotel-results-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {formatCurrency(totalFareRef.current.totalFare)}
                      </div>
                      {getEligibilityForPaymentMode('book') && (
                        <AppButton
                          btnText={formattedMessage('confirm_booking')}
                          disabled={!acceptTerms}
                          className="make-payment-btn"
                          onClick={() => payNowButtonClick('book')}
                        />
                      )}
                      {/* {getEligibilityForPaymentMode('hold') && */}
                      {roomDetails?.ratePlan?.cancellationPolicy
                        ?.freeCancellationAllowed &&
                        paymentMode === 'cashcard' && (
                          <AppButton
                            btnText="Hold Booking"
                            disabled={!acceptTerms}
                            variant="secondary"
                            onClick={() => payNowButtonClick('hold')}
                          />
                        )}
                    </div>
                  </div>
                </Col>
              ) : (
                <Col lg={9} md={12} sm={12} xs={12}>
                  <div className="separator" />
                  <div className="flight-booking-page_content">
                    <div className="flight-booking-page_header">
                      Payment options
                    </div>
                    <div className="d-flex cursor-pointer overflow-scroll">
                      {getEligibilityForPaymentMode('wallet') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 flex-column  fs-14 align-items-center justify-content-center fw-500 ${
                            paymentMode === 'cashcard'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('cashcard')}
                        >
                          <CiWallet className="fs-1" />{' '}
                          <span className="mt-2">Wallet</span>
                        </div>
                      )}

                      {getEligibilityForPaymentMode('creditcard') && (
                        <div
                          className={`flex-1 p-2 d-flex flex-column gap-1 fs-14 align-items-center justify-content-center fw-500 border-start ${
                            paymentMode === 'creditcard'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('creditcard')}
                        >
                          <MdOutlineCreditCard className="fs-1" />{' '}
                          <span className="mt-2">CreditCard</span>
                        </div>
                      )}
                      {getEligibilityForPaymentMode('debitcard') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 flex-column fs-14 align-items-center justify-content-center fw-500 border-start ${
                            paymentMode === 'debitcard'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('debitcard')}
                        >
                          <MdOutlineCreditCard className="fs-1" />{' '}
                          <span className="mt-2">DebitCard</span>
                        </div>
                      )}
                      {getEligibilityForPaymentMode('netbanking') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 fs-14 flex-column align-items-center justify-content-center fw-500 border-start ${
                            paymentMode === 'netbanking'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('netbanking')}
                        >
                          <CiBank className="fs-1" />
                          <span className="mt-2"> Netbanking</span>
                        </div>
                      )}
                      {getEligibilityForPaymentMode('upi') && (
                        <div
                          className={`flex-1 p-2 d-flex gap-1 fs-14 flex-column align-items-center justify-content-center fw-500 border-start ${
                            paymentMode === 'upi'
                              ? 'primary-color'
                              : 'grey-color'
                          }`}
                          onClick={() => setPaymentMode('upi')}
                        >
                          <CiBank className="fs-1" />
                          <span className="mt-2"> UPI</span>
                        </div>
                      )}
                    </div>

                    {paymentMode !== 'cashcard' && paymentMode !== '' && (
                      <PaymentGatewayApii
                        paymentModeClicked={paymentMode}
                        selectedPgForPaymentMode={selectedPg}
                        onPgSelect={handlePgSelect}
                      />
                    )}
                    {paymentMode !== '' &&
                      paymentMode !== 'cashcard' &&
                      selectedPg === 'payu' && (
                        <div className="px-3 d-flex flex-column">
                          <p className="mb-2 px-4 fs-14">
                            Accept Terms and Conditions of <b>payu</b>
                          </p>
                          <AppCheckBox
                            labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                            id="payuPgAccepted"
                            name="payuPgAccepted"
                            radioClassName="w-25px"
                            checked={isPayuPgAccepted}
                            labelClassName="fs-12"
                            onChange={() =>
                              setIsPayuPgAccepted((prev) => !prev)
                            }
                          />
                          <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                            <img
                              src="/images/others/payu.jpg"
                              alt=""
                              height="20px"
                            />
                            <img
                              src="/images/others/visa_mastercard.gif"
                              alt=""
                              height="20px"
                            />
                            <span>
                              (Only Personal Credit Cards @ 1.77% | Rupay Debit
                              Card allowed @0.25%)
                            </span>
                          </div>
                        </div>
                      )}
                    {paymentMode === 'netbanking' &&
                      (selectedPg === 'techprocessv2' ||
                        selectedPg === 'techprocessv2_netbanking') &&
                      paymentMode !== 'cashcard' &&
                      paymentMode !== '' && (
                        <div className="d-flex justify-content-start p-3">
                          <AppSelect
                            name="selected_bank"
                            id="selected_bank"
                            label="Select Bank"
                            placeholder=""
                            required
                            selectWidth="300px"
                            isClearable={false}
                            options={NET_BANKING_OPTIONS_LIVE}
                            selectedValue={selectedBankForNetBanking}
                            onSelect={(dataObj) =>
                              setSelectedBankForNetBanking(dataObj.value)
                            }
                          />
                        </div>
                      )}
                  </div>
                  <div className="separator" />
                  <div className="flight-booking-page_content p-2 d-flex justify-content-between flex-column flex-sm-row gap-sm-0 gap-2">
                    <div className="d-flex align-items-center cursor-pointer">
                      <AppCheckBox
                        labelText={formattedMessage(
                          'i_have_read_and_accept_terms_and_conditions',
                        )}
                        id="acceptTerms"
                        name="acceptTerms"
                        checked={acceptTerms}
                        labelClassName="fs-12"
                        onChange={() => setAcceptTerms((prev) => !prev)}
                      />
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            {isMobileWidth() && (
              <div className="bookingpage-footer d-flex  justify-content-between ">
                <div className=" white-color">
                  <div className="fs-14 fw-500">
                    <div>Total Amount</div>
                  </div>
                  <div
                    onClick={() => setViewFareSummary(true)}
                    className="d-flex align-items-center"
                  >
                    {formatCurrency(totalFareRef.current.totalFare)}{' '}
                    <MdKeyboardArrowDown />
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-3">
                  {getEligibilityForPaymentMode('hold') &&
                    paymentMode === 'cashcard' && (
                      <AppButton
                        btnText="Hold"
                        disabled={!acceptTerms}
                        variant="secondary"
                        onClick={payNowButtonClick}
                      />
                    )}
                  {getEligibilityForPaymentMode('book') && (
                    <AppButton
                      btnText="Confirm"
                      disabled={!acceptTerms}
                      className="make-payment-btn"
                      onClick={payNowButtonClick}
                    />
                  )}
                </div>
              </div>
            )}

            {showTerms && (
              <AppModal
                modalTitle={formattedMessage('terms_conditions')}
                backdrop="renderbackdrop"
                showCloseButton
                size="md"
                onModalClose={() => setShowTerms(false)}
              >
                <TermsAndConditions tAndC={roomDetails.ratePlan.tncPolicy} />
              </AppModal>
            )}
            {showConfirmationPopup && (
              <AppModal
                modalTitle="Confirm Booking"
                size="lg"
                showCloseButton
                onModalClose={() => setShowConfirmationPopup(false)}
              >
                <div>
                  <div className="booking-review-page__body">
                    <div className="booking-review-page__body_content">
                      <div className="d-flex flex-sm-row flex-column">
                        <div>
                          <img
                            src={
                              hotelDetails?.thumbnail ||
                              '/images/others/hotel-empty.jpg'
                            }
                            alt={formattedMessage('room')}
                            width="150px"
                            height="100%"
                            onError={(e) =>
                              (e.target.src = '/images/others/hotel-empty.jpg')
                            }
                          />
                        </div>
                        <div className="d-flex flex-column px-3 py-2">
                          <div className="d-flex gap-2 flex-wrap">
                            <span className="booking-review-page__body__booking-details_hotel-name">
                              {hotelDetails.propertyName}
                            </span>
                            <StarRating rating={hotelDetails.starRating} />
                          </div>
                          <span className="booking-review-page__body__booking-details_hotel-location">
                            {hotelDetails.shortaddr}
                          </span>
                          <div className="d-flex gap-2 flex-column flex-sm-row mt-2">
                            <div className="d-flex gap-2">
                              <CheckInCard
                                data={{
                                  title: formattedMessage('check_in'),
                                  date: searchRequest.checkInSearch,
                                  time:
                                    hotelDetails.checkInTime ||
                                    formattedMessage('n_a'),
                                }}
                              />
                              <CheckInCard
                                data={{
                                  title: formattedMessage('check_out'),
                                  date: searchRequest.checkOutSearch,
                                  time:
                                    hotelDetails.checkOutTime ||
                                    formattedMessage('n_a'),
                                }}
                              />
                            </div>
                            <div className="booking-review-page__body__room-details">
                              <div className="fs-16 fw-600">
                                {roomDetails.roomType.roomTypeName}
                              </div>
                              <div className="fs-14 mb-2">
                                {formattedMessage('for')}{' '}
                                {searchRequest.totalPeople}{' '}
                                {formattedMessage('people')}
                              </div>
                              <div className="d-flex gap-2 fs-14">
                                <span className="primary-color">{}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="px-3 py-2">
                      <div className="p-2 border">
                        <span className="fs-14 fw-500">
                          {formattedMessage('inclusions')}
                        </span>
                        {' : '}
                        <span className="fs-14">
                          {roomDetails?.ratePlan?.inclusions.join(', ')}
                          {/* {hotelDetails.amenitiesList?.join(', ')} */}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    {selectedRooms.map((room, index) => (
                      <div key={index} className="px-2 py-1">
                        <div className="fs-14 fw-500">Room {index + 1}</div>
                        {room.roomPassengers.paxList.map((pax, paxIndex) => (
                          <div
                            key={paxIndex}
                            className="d-flex gap-2 align-items-center"
                          >
                            <span className="fs-12 grey-color">
                              Guest {paxIndex + 1}
                            </span>
                            <span className="fs-14 fw-500">{`${pax.title} ${pax.firstName} ${pax.lastName}`}</span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                  <div className="pt-2 border-top overflow-auto">
                    <div className="flex-1 d-flex gap-2">
                      <div className="d-flex flex-column flex-1 me-2">
                        <span className="fs-12 grey-color">Total Amount</span>
                        <span
                          className="fs-12 fw-600 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(totalFareRef.current.totalFare)}
                        </span>
                      </div>
                      <div className="d-flex flex-column flex-1 me-2">
                        <span className="fs-12 grey-color">
                          {formattedMessage('payment_surcharge')}
                        </span>
                        <span
                          className="fs-12 fw-600 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(checkoutPgCharge)}
                        </span>
                      </div>
                      <div className="d-flex flex-column flex-1 me-2">
                        <span className="fs-12 grey-color">
                          GST on Payment Surcharge
                        </span>
                        <span
                          className="fs-12 fw-600 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(checkoutgstPgCharge)}
                        </span>
                      </div>
                      <div className="d-flex flex-column flex-1 me-2">
                        <span className="fs-12 grey-color">
                          {formattedMessage('you_pay')}
                        </span>
                        <span
                          className="fs-12 fw-60 hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(checkoutInvTotal)}
                        </span>
                      </div>
                      <AppButton
                        variant="outlined"
                        btnText="Cancel"
                        onClick={() => setShowConfirmationPopup(false)}
                        className="fs-14 px-3"
                      />
                      {paymentMode === 'cashcard' && (
                        <AppButton
                          variant="secondary"
                          btnText="Hold"
                          className="fs-14 px-3"
                          onClick={holdHotel}
                        />
                      )}

                      {getEligibilityForPaymentMode('book') && (
                        <AppButton
                          variant="primary"
                          btnText="Book Now"
                          onClick={bookAHotel}
                          className="fs-14 px-3"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </AppModal>
            )}
            {viewFareSummary && (
              <AppSidebar
                sidebarTitle={
                  <div className="fw-600 d-flex justify-content-between align-items-center">
                    <div>{formattedMessage('charges')}</div>
                    <AppIconButton
                      className="p-0 fs-16"
                      variant="white"
                      onClick={() => setShowNetFare((prev) => !prev)}
                    >
                      {showNetFare ? <IoMdEyeOff /> : <IoMdEye />}
                    </AppIconButton>
                  </div>
                }
                onHideSidebar={() => setViewFareSummary(false)}
                animatedClass="slide-from-right-animation"
                className="app-mobile-datepicker-modal booking-review-page"
              >
                {isMobileWidth() && (
                  <div className="hotel-fare-summary">
                    <div className="hotel-fare-summary_content">
                      {getValueFromAppConfig(
                        'HIDEBREAKUPINHOTELBOOKINGPAGE',
                      ) !== 'true' && (
                        <>
                          <div className="row spacing-0">
                            <div className="col-auto">
                              {formattedMessage('hotel_charges')}(+)
                            </div>
                            <div
                              className="col hotel-results-watermarked"
                              data-watermark={`${getUserAgentId()}`}
                            >
                              {formatCurrency(
                                parseInt(fareBreakup[0], 10) -
                                  parseInt(totalFareRef.current.totalTax, 10),
                              )}
                            </div>
                          </div>
                          <div className="row spacing-0">
                            <div className="col-auto">
                              Taxes & Service Charges(+)
                            </div>
                            <div
                              className="col hotel-results-watermarked"
                              data-watermark={`${getUserAgentId()}`}
                            >
                              {formatCurrency(
                                parseInt(totalFareRef.current.totalTax, 10) +
                                  parseInt(fareBreakup[8], 10) +
                                  parseInt(fareBreakup[6], 10) +
                                  parseInt(fareBreakup[4], 10),
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {showNetFare && (
                        <>
                          {getValueFromAppConfig(
                            'HIDEBREAKUPINHOTELBOOKINGPAGE',
                          ) !== 'true' && (
                            <>
                              <div className="row spacing-0">
                                <div className="col-auto">
                                  {formattedMessage('agency_commission')}(-)
                                </div>
                                <div
                                  className="col hotel-results-watermarked"
                                  data-watermark={`${getUserAgentId()}`}
                                >
                                  {formatCurrency(fareBreakup[3])}
                                </div>
                              </div>
                              <div className="row spacing-0">
                                <div className="col-auto">
                                  {formattedMessage('tds')}(+)
                                </div>
                                <div
                                  className="col hotel-results-watermarked"
                                  data-watermark={`${getUserAgentId()}`}
                                >
                                  {formatCurrency(fareBreakup[5])}
                                </div>
                              </div>
                            </>
                          )}
                          <div className="row spacing-0">
                            <div className="col-auto">Net Fare</div>
                            <div
                              className="col hotel-results-watermarked"
                              data-watermark={`${getUserAgentId()}`}
                            >
                              {formatCurrency(fareBreakup[9])}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="bg-body-secondary fs-12 fw-600 p-3">
                      <div className="d-flex justify-content-between">
                        <span>{formattedMessage('total_fare')}</span>
                        <span
                          className=" hotel-results-watermarked"
                          data-watermark={`${getUserAgentId()}`}
                        >
                          {formatCurrency(totalFareRef.current.totalFare)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </AppSidebar>
            )}
          </div>
        )}
        {priceChangeModal && (
          <AppModal
            modalTitle="Price Change Alert !"
            okText="Ok"
            cancelText="Back"
          >
            <div>
              <h6>
                Price has been changed to {roomDetails.nextrafarequoteprice}.
              </h6>
              <div className="fs-12">Click OK to proceed booking.</div>
              <div className="p-3 d-flex justify-content-end gap-2">
                <AppButton
                  btnText="Back"
                  variant="secondary"
                  onClick={() => navigate(-1)}
                />
                <AppButton
                  btnText="Ok"
                  variant="primary"
                  onClick={() => setPriceChangeModal(false)}
                />
              </div>
            </div>
          </AppModal>
        )}
      </section>
    </>
  );
}

BookingReview.defaultProps = {};

BookingReview.propTypes = {};

export default BookingReview;
